import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="toggle-element"
export default class extends Controller {
  static targets = ["template", "destination"];
  static values = { show: Boolean };

  connect() {
    this.handle({ params: { show: this.showValue } });
  }

  handle({ params }) {
    if (params.show) {
      this.destinationTarget.innerHTML = this.templateTarget.innerHTML;
    } else {
      this.destinationTarget.innerHTML = "";
    }
  }
}
